<!--应收费用-->
<template>
  <div>
    <div v-if="type === 1" class="feet-r">
      <!-- 添加/修改费用-->
      <el-popover placement="bottom-start" trigger="hover">
        <div class="feet">
          <!--批量添加费用-->
          <el-button
            size="small"
            type="primary"
            class="feet-btn"
            @click="operationBtn(1)"
          >{{ $t('receivablePayable.AddChargesInBulk') }}
          </el-button>
          <!--批量修改费用-->
          <el-button
            size="small" type="primary" class="feet-btn"
            @click="operationBtn(2)"
          >{{ $t('receivablePayable.batchModifyFees') }}
          </el-button>
          <!--导入添加费用-->
          <el-button
            size="small"
            type="primary" class="feet-btn"
            @click="importFees(1)"
          >{{ $t('receivablePayable.ImportAddCharges') }}
          </el-button>
          <!--导入修改费用-->
          <el-button
            size="small"
            type="primary" class="feet-btn"
            @click="importFees(2)"
          >{{ $t('receivablePayable.ImportModifyExpenses') }}
          </el-button>
          <!--快录-->
          <el-button
            size="small"
            type="primary" class="feet-btn"
            @click="quickRecord(1)"
          >{{ $t('receivablePayable.QuickRecord') }}
          </el-button>
          <!--批量导入快录-->
          <el-button
            size="small"
            type="primary" class="feet-btn"
            @click="quickRecord(2)"
          >{{ $t('receivablePayable.BatchImportClips') }}
          </el-button>
          <!--单号批量删除费用-->
          <el-button
            size="small"
            type="primary" class="feet-btn"
            @click="delOrder"
          >{{ $t('receivablePayable.BatchDeleteExpensesByOrderNo') }}
          </el-button>
        </div>
        <template #reference>
          <!-- 添加/修改费用-->
          <el-button
            v-permit:remove="'btn:aRGeneration:addCharge'"
            size="small"
          >
            {{ $t('receivablePayable.AddModifyExpenses') }}
          </el-button>
        </template>
      </el-popover>

      <!--生成应收-->
      <el-popover placement="bottom-start" trigger="hover">
        <el-button
          size="small"
          type="primary"
          @click="operationBtn(3)"
        >{{ $t('receivablePayable.GenerateReceivables') }}
        </el-button>
        <!-- 导入生成应收 -->
        <import-receivable-generation
          :fee-type-options="feeList"
          :type="2"
        />
        <!--生成应收-->
        <template #reference>
          <el-button
            v-permit:remove="'btn:aRGeneration:generate'"
            size="small"
            type="primary"
          >{{ $t('receivablePayable.GenerateReceivables') }}
          </el-button>
        </template>
      </el-popover>

      <!--备注-->
      <el-button
        v-permit:remove="'btn:aRGenerationNew:remarks'"
        size="small"
        @click="operationBtn(5)"
      >{{ $t('receivablePayable.remark') }}
      </el-button>

      <!--导出-->
      <ExportButCmp
        :query-form="queryForm"
        :select-data="selectData"
        :current-columns="currentColumns"
      />

      <!--重新计算价格-->
      <el-popover placement="bottom-start" trigger="hover">
        <!--重新计算价格-->
        <div class="feet">
          <el-button
            size="small"
            type="primary"
            @click="operationBtn(7)"
          >{{ $t('receivablePayable.RecalculateThePrice') + '(' + $t('receivablePayable.Maximum100000') + ')' }}
          </el-button>
          <template v-if="type !== 2">
            <!--导入计算价格-->
            <el-button
              size="small"
              type="primary"
              class="feet-btn"
              @click="getImportTemplate(2)"
            >{{ $t('receivablePayable.ImportCalculatePrices') }}
            </el-button>
            <!--导入重量计算价格-->
            <el-button
              size="small"
              type="primary"
              class="feet-btn"
              @click="getImportTemplate(3)"
            >{{ $t('receivablePayable.ImportWeightsCalculatePrices') }}
            </el-button>
            <!--导入邮编计算-->
            <el-button
              size="small"
              type="primary"
              class="feet-btn"
              @click="postcodeCalculation(5)"
            >{{ $t('receivablePayable.ImportPostcodeCalculation') }}
            </el-button>
          </template>
        </div>
        <template #reference>
          <el-button
            v-permit:remove="'btn:aRGenerationNew:RecalculateThePrice'"
            size="small"
          >{{ $t('receivablePayable.RecalculateThePrice') }}
          </el-button>
        </template>
      </el-popover>

      <!--删除-->
      <el-button
        v-permit:remove="'btn:aRGenerationNew:deleteRow'"
        size="small"
        type="danger"
        @click="deleteRow"
      >{{ $t('receivablePayable.Delete') }}
      </el-button>

      <!--自定义栏目-->
      <CustomStatusBar
        :columns-data="columns"
        :params="searchParams"
        :save-params="customParams"
        class="feet-btn"
        @updateColumns="updateColumns"
      />

      <!--推送快手揽收费-->
      <el-button
        v-if="type === 1"
        v-permit:remove="'btn:aRGeneration:PushFastHandCharge'"
        size="small"
        type="primary"
        @click="onPushFastHandCharge"
      >{{ $t('orderCenterCont.PushFastHandCharge') }}
      </el-button>
    </div>

    <!--自定义栏目-->
    <CustomStatusBar
      :columns-data="columns"
      :params="searchParams"
      :save-params="customParams"
      class="feet-btn"
      @updateColumns="updateColumns"
    />

    <!--批量添加费用-->
    <el-drawer
      :append-to-body="true"
      :title="addType === 1 ? $t('receivablePayable.AddChargesInBulk') : $t('receivablePayable.FeeDetails')"
      :visible.sync="showBatchAdd"
      custom-class="drawerClass"
      direction="ltr"
      size="80%"
    >
      <batch-add-fee
        :key="batchAddKey"
        :type="type"
        :add-type="addType"
        :fee-type-option="feeList"
        :query-fee-param="queryFeeParam"
        :query-form="queryForm"
        :select-data="selectData"
        @saveForm="saveForm"
      />
    </el-drawer>

    <!--快录添加费用-->
    <el-drawer
      :append-to-body="true"
      :title="$t('receivablePayable.SnapshotFee')"
      :visible.sync="showAddSnapshotFee"
      custom-class="drawerClass"
      direction="ltr"
      size="80%"
    >
      <add-snapshot-fee
        :key="snapshotFeeKey"
        :expense-sub-list="expenseSubList"
        :fee-type-option="feeList"
        :query-fee-param="queryFeeParam"
        @saveFormSnapshot="saveFormSnapshot"
      />
    </el-drawer>

    <!--导入添加、 修改费用-->
    <el-dialog
      :title="expensesType === 1 ? $t('receivablePayable.ImportAddCharges') : $t('receivablePayable.ImportModifyExpenses')"
      :visible.sync="showModification"
      width="400px"
    >
      <div v-if="expensesType === 1">
        <import-add-fee @changeFeeList="changeFeeList" />
      </div>
      <div v-else-if="expensesType === 2">
        <batch-change @changeFeeList="changeFeeList" />
      </div>
    </el-dialog>

    <!--导入快录-->
    <el-dialog
      :title="$t('receivablePayable.BatchImportClips')"
      :visible.sync="showBatchImportClips"
      width="400px"
    >
      <batch-import-clips
        :key="snapshotImportClips"
        :outlets-list="[]"
        @importClips="importClips"
      />
    </el-dialog>

    <!-- 批量修改费用 -->
    <ModifyFee
      ref="modifyFeeRef"
      :fee-type-option="feeList"
      :query-form="queryForm"
      :select-data="selectData"
      @close="searchFun"
    />

    <!--   按单号批量删除费用-->
    <el-dialog
      :title="$t('receivablePayable.BatchDeleteExpensesByOrderNo')"
      :visible.sync="showBatchDeleteExpensesByOrderNo"
      width="400px"
    >
      <BatchDelOrder
        :key="batchDeleteExpensesByOrderNo"
        :fee-type-option="feeList"
        @importDelOrder="importDelOrder"
      />
    </el-dialog>

    <!--    生成应收账单-->
    <ReceivableDialog
      ref="receivableRefDialog"
      :select-data="selectData"
      :query-form="queryForm"
      @change="searchTable"
    />

    <!--    备注-->
    <RemarkDialog
      ref="remarkRefDialog"
      :select-data="selectData"
      :query-form="queryForm"
      @change="searchTable"
    />

    <!--    删除费用-->
    <DelFeeDialog
      ref="delRefDialog"
      :select-data="selectData"
      :query-form="queryForm"
      :fee-list="feeList"
      @change="searchTable"
    />

    <!--重新计算价格-->
    <el-dialog
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('receivablePayable.RecalculateThePrice')"
      :visible.sync="recalculate"
      width="80%"
      @close="changePage(false)"
    >
      <recalculatePrice
        :key="showManage1"
        :calculation-type="0"
        :get-param="queryForm"
        :import-data="importData"
        :select-data="selectData"
        @changePage="changePage"
      />
    </el-dialog>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash-es';
import ExportButCmp from '@/views/finance/receivableManagementSite/aRGenerationNew/cmp/ExportButCmp/index.vue';
import importReceivableGeneration from '@/views/finance/receivableManagementSite/aRGenerationNew/cmp/importReceivableGeneration.vue';
import {
  apiFinancialExpressKwai,
  apiPayableSiteBatchFastInputFee,
  apiPayableSiteExpenseDeleteFee
} from '@/api/finance/receivables';
import { TABLE_HEADER, VEHICLERECEIVABLES_COLUMN } from '../utils';
import batchAddFee from '@/views/finance/receivableManagementSite/aRGenerationNew/cmp/batchAddFee.vue';
import addSnapshotFee from '@/views/finance/receivableManagementSite/aRGenerationNew/cmp/addSnapshotFee.vue';
import importAddFee from '@/views/finance/receivableManagementSite/aRGenerationNew/cmp/importAddFee.vue';
import batchChange from '@/views/finance/receivableManagementSite/aRGenerationNew/cmp/batchChange.vue';
import recalculatePrice from '@/views/finance/receivableManagementSite/aRGenerationNew/cmp/recalculatePrice.vue';
import batchImportClips from '@/views/finance/receivableManagementSite/aRGenerationNew/cmp/batchImportClips.vue';
import { goFileUploadManagement } from '@/utils/goExportList';

export default {
  name: 'ActionCenter',
  components: {
    batchImportClips,
    recalculatePrice,
    batchChange,
    importAddFee,
    addSnapshotFee,
    batchAddFee,
    importReceivableGeneration,
    ExportButCmp,
    CustomStatusBar: () => import('@/components/customStatusBar/index.vue'),
    ReceivableDialog: () => import('./Dialog/receivableDialog.vue'),
    RemarkDialog: () => import('./Dialog/remarkDialog.vue'),
    DelFeeDialog: () => import('./Dialog/delFeeDialog.vue'),
    ModifyFee: () => import('../cmp/modifyFee.vue'),
    BatchDelOrder: () => import('../cmp/batchDelOrder.vue')
  },

  props: {
    // 1 快递应收 2 整车应收
    type: {
      type: Number,
      default: 1
    },
    // 自定义列
    searchParams: {
      type: Object,
      default: () => ({})
    },
    customParams: {
      type: Object,
      default: () => ({})
    },
    // 选中的数据
    selectData: {
      type: Array,
      default: () => []
    },
    // 查询参数
    queryForm: {
      type: Object,
      default: () => ({})
    },
    // 费用类型
    feeList: {
      type: Array,
      default: () => []
    },
    // 选择费用详情
    queryFeeParam: {
      type: Object,
      default: () => ({})
    },
    // 表格数据
    tableData: {
      type: Array,
      default: () => []
    },
    expenseSubList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      TABLE_HEADER,
      VEHICLERECEIVABLES_COLUMN,
      handlerId: '',
      currentColumns: [],
      showBatchAdd: false,
      addType: 1,
      batchAddKey: new Date().getTime(),
      // 快录
      showAddSnapshotFee: false,
      snapshotFeeKey: new Date().getTime(),
      expensesType: null,
      showModification: false,
      recalculate: false,
      showManage1: new Date().getTime(),
      importData: [],
      showBatchImportClips: false,
      snapshotImportClips: new Date().getTime(),
      showBatchDeleteExpensesByOrderNo: false,
      batchDeleteExpensesByOrderNo: new Date().getTime()
    };
  },
  computed: {
    columns() {
      return this.type === 1 ? this.TABLE_HEADER : this.VEHICLERECEIVABLES_COLUMN;
    }
  },
  watch: {
    queryFeeParam: {
      handler(val) {
        console.log('费用详情431', val, !val);
        if (val) {
          this.viewFeeDetail();
        }
      },
      deep: true
    }
  },
  methods: {
    // 更新自定义栏目columns
    updateColumns(list) {
      this.$emit('Columns', list);
    },

    /**
     * 操作按钮
     * @param type 1 批量添加费用 2 批量修改费用 3 生成应收 5 备注 7 重算
     */
    operationBtn(type) {
      const ids = [];
      if (this.selectData.length > 0) {
        this.selectData.map(item => {
          ids.push(item.id);
        });
      }
      // 查询费用表
      if (this.tableData.length === 0) {
        this.$message.warning(this.$t('receivablePayable.businessTimeOrOrderNumberCannotBeEmpty'));
        return;
      }
      // 批量添加费用
      if (type === 1) {
        this.batchAdd();
      }
      // 批量修改费用
      if (type === 2) {
        this.batchModify();
      }
      // 应收生成
      if (type === 3) {
        this.generateBill();
      }
      // 添加备注
      if (type === 5) {
        this.addNotes();
      }
      // 重新计算价格
      if (type === 7) {
        this.changeRecalculate();
      }
    },
    // 批量添加费用
    batchAdd() {
      const { businessType, customerId } = this.queryForm;
      console.log('批量添加费用', businessType, customerId);
      if (businessType === null || businessType === '' || businessType === undefined || !customerId) {
        this.$message.warning(this.$t('receivablePayable.PleaseFilterBusinessCustomer')); // 请筛选相同业务类型同一客户的数据进行批量添加费用
        return;
      }
      this.addType = 1;
      this.queryFeeParam = {
        billingMethod: this.tableData[0].billingMethod
      };
      this.showBatchAdd = true;
      this.batchAddKey = new Date().getTime();
    },
    // 批量修改费用
    batchModify() {
      const { businessType, customerId } = this.queryForm.params;
      if (!businessType && !customerId) {
        this.$message.warning(this.$t('receivablePayable.filterSameBusinessTypeAndCustomerForBatchModify')); // 请筛选相同业务类型同一客户的数据进行批量修改费用
        return;
      }
      this.$refs.modifyFeeRef.open();
    },
    // 应收生成账单
    generateBill() {
      this.$refs.receivableRefDialog.openDialog();
    },
    // 添加备注
    addNotes() {
      this.$refs.remarkRefDialog.open();
    },
    // 重新计算价格
    changeRecalculate() {
      let msg = '';
      if (this.selectData.length > 0) {
        this.calculationType = 1;
        msg = this.$t('receivablePayable.PressRecalculateWithChecked');
      } else {
        this.calculationType = 0;
        msg = this.$t('receivablePayable.Recalculate');
      }
      // 按结果计算
      if (this.queryForm.params.businessType === 1) {
        if (this.queryForm.params.collectionCategory === null) {
          // 业务类型为揽收时揽收类别不能为空
          this.$message.warning(this.$t('receivablePayable.BusinessTypePickupPickupCategoryCannotEmpty'));
          return;
        }
      }

      this.$confirm(
        msg, // 点击”确认“按钮，将按照系统最新价格表对当前查询的所有“费用来源”为“系统生成”的费用进行重新核算，是否确认？
        this.$t('basicData.tips'),
        {
          confirmButtonText: this.$t('basicData.determine'), // '确定',
          cancelButtonText: this.$t('basicData.Cancel'), // '取消',
          type: 'warning'
        }
      ).then(() => {
        this.showManage1 = new Date().getTime();
        this.recalculate = true;
      }).catch(() => {
      });
    },

    // 打开批量添加修改费用弹窗
    importFees(type) {
      this.expensesType = type;
      this.showModification = true;
    },

    // 打开导入计算价格
    getImportTemplate(type) {
      this.importData = [];
      this.calculationType = type;
      this.showImportTemplate = true;
    },

    // 导入邮编计算
    postcodeCalculation(type) {
      this.calculationType = type;
      this.showImportTemplate = true;
      this.importData = [];
    },

    // 打开删除费用弹窗
    deleteRow() {
      this.$refs.delRefDialog.open();
    },

    // 单号批量删除费用
    delOrder() {
      this.showBatchDeleteExpensesByOrderNo = true;
      this.batchDeleteExpensesByOrderNo = new Date().getTime();
    },

    /**
     * 快录费用
     * @param type  1 新增 2 导入
     */
    quickRecord(type) {
      if (type === 1) {
        if (this.selectData.length > 0) {
          this.queryFeeParam = cloneDeep(this.selectData[0]);
          this.queryFeeParam.waybillNumber = this.queryFeeParam.waybillNumber.replace('QR', '');
          this.queryFeeParam.id = null;
        } else {
          this.queryFeeParam = {
            id: null,
            waybillNumber: '', // 业务单号
            customerId: '', // 客户id
            customerAlias: '', // 客户别称
            providerId: '', // 业务主体id
            siteId: '', // 网点id
            siteName: '', // 网点名称
            chargeWeight: '', // 计费重量
            businessType: '', // 业务类型
            collectionCategory: '', // 揽收类型
            settlementMethod: undefined, // 结算方式
            remark: '', // 备注
            isSynchronous: false
          };
        }
        this.showAddSnapshotFee = true;
        this.snapshotFeeKey = new Date().getTime();
      } else {
        this.showBatchImportClips = true;
        this.snapshotImportClips = new Date().getTime();
      }
    },

    // 推送快手揽收费
    onPushFastHandCharge() {
      const selectedColumn = cloneDeep(this.selectData);
      const name = 'kwai';

      const query = {
        customerId: 0, // 客户只能是 kuai,才能有此操作
        waybillNumberList: ''
      };

      // 没有选中
      if (selectedColumn.length === 0) {
        this.$message.warning(this.$t('receivablePayable.KuaiFee'));
        return;
      }

      // 筛选出客户为 kuai 的（这里只能通过中文名称检测，不考虑同名情况，实际校验由后端完成）
      const arr = selectedColumn.filter(item => {
        return item.customerAlias === name;
      }).map(item => {
        // 设置客户
        query.customerId = item.customerId;
        return item.waybillNumber;
      });

      console.log(arr, 'kwai单号');
      // 选中的项没有 kuai
      if (arr.length === 0) {
        this.$message.warning(this.$t('receivablePayable.KuaiFee'));
        return;
      }

      query.waybillNumberList = arr.join(',');
      apiFinancialExpressKwai(query).then(res => {
        const { data } = res;
        const msg = Object.entries(data || {}).map(item => {
          const [key, value] = item;
          return key + '：' + value;
        }).join('；');
        this.$message({
          message: msg
        });
      }).catch(err => {
        console.error(err);
      });
    },

    // 批量添加费用保存
    saveForm(type) {
      this.showBatchAdd = false;
      this.batchAddKey = new Date().getTime();
      if (type === 2) {
        // 保存后刷新列表
        this.searchTable();
      }
    },

    // 保存、关闭添加快录弹窗
    saveFormSnapshot() {
      this.showAddSnapshotFee = false;
      this.searchTable();
    },

    // 导入添加、修改费用
    changeFeeList(type) {
      if (type === true) {
        this.searchTable();
      }
      this.showModification = false;
    },

    // 导入快录
    importClips(data) {
      apiPayableSiteBatchFastInputFee(data).then(res => {
        if (res.code === 200) {
          goFileUploadManagement(this);
          this.showBatchImportClips = false;

          this.searchTable();
        }
      });
    },

    // 查询
    searchFun(params) {
      console.log(params);
      goFileUploadManagement(this);
      this.searchTable();
    },

    // 关闭重新计算价格弹窗
    changePage(type) {
      this.importData = [];
      this.recalculate = false;
      if (type === true) {
        this.searchTable();
      }
    },

    importDelOrder(data) {
      apiPayableSiteExpenseDeleteFee(data).then(res => {
        if (res.code === 200) {
          this.showBatchDeleteExpensesByOrderNo = false;

          goFileUploadManagement(this);
        }
      });
    },

    // 查看费用详情/批量添加费用
    viewFeeDetail() {
      const { feeSource } = this.queryFeeParam;
      this.addType = feeSource === 0 ? 2 : 1;
      if (feeSource === 0) {
        this.showBatchAdd = true;
      }
    },

    // 刷新table
    searchTable() {
      console.log('更新列表');
    }
  }
};
</script>

<style scoped lang="scss">

</style>
